import React from 'react'
import ReportPrevNextButtons from './ReportPrevNextButtons'
import { Alert, Button, Grid } from '@mui/material'
import StarIcon from '@mui/icons-material/Star'
import { Link } from 'react-router-dom'
import {
  GetReportDetailsQuery,
  GetReportFavoriteDetailsQuery,
  useCreatePdfReportMutation,
} from 'gqlTypes'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'

interface Props {
  report:
    | NonNullable<GetReportDetailsQuery['report']>
    | NonNullable<GetReportFavoriteDetailsQuery['reportWithFavorites']>
  sectionId: string
  favorites?: boolean
}

const ReportNavigation: React.FC<Props> = ({
  report,
  sectionId,
  favorites = false,
}) => {
  const [createPdfReport] = useCreatePdfReportMutation()
  const handleDownloadFavoritesPdf = () => {
    createPdfReport({
      variables: { input: { reportId: report.id, onlyFavorites: true } },
    }).then((rslt) => {
      const createPdfReport = rslt.data?.createPdfReport
      if (
        createPdfReport &&
        createPdfReport.success &&
        createPdfReport.pdfReport
      ) {
        const url = `/pdf/${createPdfReport.pdfReport.randomKey}`
        window.open(url, '_blank')
      }
    })
  }
  return (
    <>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
      >
        <Grid item>
          <ReportPrevNextButtons
            favorites={favorites}
            report={report}
            sectionId={sectionId}
          />
        </Grid>

        {favorites && report.sections.length > 0 && (
          <Grid item>
            <Alert severity="info" variant="filled">
              You are viewing bookmarks for this report. This is not the full
              report.
            </Alert>
          </Grid>
        )}
        <Grid item>
          <div style={{ textAlign: 'right' }}>
            {!favorites && (
              <Grid item>
                <Button
                  reloadDocument
                  variant="outlined"
                  startIcon={<StarIcon color="primary" />}
                  component={Link}
                  to={`/report_bookmarks/${report.id}/sections/${sectionId}`}
                >
                  View Bookmarks
                </Button>
              </Grid>
            )}
            {favorites && report.sections.length > 0 && (
              <Button
                reloadDocument
                variant="outlined"
                endIcon={<ArrowForwardIcon color="primary" />}
                component={Link}
                to={`/reports/${report.id}/sections/${sectionId}`}
              >
                Return to the full report
              </Button>
            )}
            {favorites && (
              <Button
                variant="outlined"
                color="primary"
                startIcon={<PictureAsPdfIcon />}
                sx={{ width: '100%', maxWidth: '300px', mb: 1 }}
                onClick={handleDownloadFavoritesPdf}
              >
                Download Bookmark PDF
              </Button>
            )}
          </div>
        </Grid>
      </Grid>
    </>
  )
}

export default ReportNavigation
